const handleAddressChange = (event, result, setAddressValue, setFieldValue, addressValue) => {
    const { name, value } = result || event.target;
    setAddressValue({ ...addressValue, [name]: value });
    setFieldValue('addressField', value);
  };

  export default handleAddressChange;